export const errors: Map<string, string> = new Map([
  ['User_Not_Valid', "L'utilisateur n'est pas valide."],
  ['Login_Not_Valid', "L'identifiant de l'utilisateur n'est pas valide."],
  ['Id_Not_Valid', "L'id de l'utilisateur n'est pas valide."],
  ['Email_Not_Valid', "Le mail de l'utilisateur n'est pas valide."],
  ['Phone_Not_Valid', "Le téléphone de l'utilisateur n'est pas valide."],
  [
    'Code_Validation_Not_Valid',
    "Le code de validation de l'utilisateur n'est pas valide.",
  ],
  [
    'Code_Validation_Already_Validated',
    "Le code de validation de l'utilisateur a déjà été validé.",
  ],
  ['Organisme_Not_Valid', "L'organisme n'est pas valide."],
  ['Id_Organisme_Not_Valid', "L'id de l'organisme n'est pas valide."],
  ['Crpcen_Organisme_Not_Valid', "Le crpcen de l'organisme n'est pas valide."],
  ['User_Already_Used', 'Un utilisateur avec cet identifiant existe déjà.'],
  [
    'Email_Already_Used',
    'Un utilisateur avec ce mail existe déjà, veuillez saisir un mail différent.',
  ],
  ['User_To_Create_Not_Valid', "L'utilisateur a créer n'est pas valide."],
  [
    'User_To_Create_Lastname_Not_Valid',
    "Le nom de l'utilisateur a créer n'est pas valide.",
  ],
  [
    'User_To_Create_Firstname_Not_Valid',
    "Le prenom de l'utilisateur a créer n'est pas valide.",
  ],
  [
    'User_To_Create_Email_Not_Valid',
    "Le mail de l'utilisateur a créer n'est pas valide.",
  ],
  [
    'User_To_Create_Email_Already_Exist',
    "Le mail de l'utilisateur a créer existe déjà.",
  ],
  ['User_To_Validate_Not_Valid', "L'utilisateur a valider n'est pas valide."],
  [
    'User_To_Validate_Login_Not_Valid',
    "Le login de l'utilisateur à valider n'est pas valide.",
  ],
  [
    'User_To_Validate_CodeValidation_Not_Valid',
    "Le code de validation de l'utilisateur à valider n'est pas valide.",
  ],
  [
    'User_Cant_Create_User',
    "L'utilisateur' n'a pas les droits pour créer un utilisateur.",
  ],
  [
    'User_Cant_Update_User',
    "L'utilisateur' n'a pas les droits pour mettre à jour cet utilisateur.",
  ],
  [
    'User_Cant_Access_User',
    "L'utilisateur' n'a pas les droits pour accéder à cet utilisateur.",
  ],
  [
    'EMAIL.INVALID_FORMAT',
    "L'adresse e-mail n'est pas au bon format. Veuillez saisir une adresse e-mail valide.",
  ],
  [
    'PASSWORD.INVALID_FORMAT',
    'Votre mot de passe contient des caractères non valides. Il doit contenir au moins un chiffre, au moins une majuscule, au moins une minuscule, au moins 12 caractères et au moins un caractère spécial',
  ],
  ['LOGIN.INVALID_FORMAT', 'Cet identifiant est déjà pris'],
  ['PASSWORD.ALREADY_USED', 'Votre mot de passe a déjà été utilisé'],
  [
    'DEFAULT',
    'Une erreur est survenue, veuillez réessayer plus tard ou contacter le support',
  ],
  [
    'INTERNAL_SERVER_ERROR',
    'Une erreur est survenue, veuillez réessayer plus tard ou contacter le support',
  ],
  ['EMAIL.INVALID_FORMAT', 'L’e-mail n’est pas au bon format.'],
  ['PASSWORD.NOT_THE_SAME', 'Les mots de passe ne sont pas identiques.'],
  ['SECURITY_CODE.MISMATCH', 'Le code de sécurité n’est pas bon.'],
  ['SECURITY_CODE.EXPIRED', 'Le code de sécurité a expiré.'],
  ['PASSWORD.INVALID_FORMAT', 'Le mot de passe n’est pas valide.'],
  ['PASSWORD.ALREADY_USED', 'Le mot de passe a déjà été utilisé.'],
  ['USER.NOT_CONFIRMED', 'L’utilisateur n’a pas confirmé son compte.'],
  [
    'END_DATE_AFTER_START_DATE_MAX',
    'La date de fin ne peut pas être avant la date de début.',
  ],
  [
    'START_DATE_AFTER_TODAY',
    "La date de début ne peut pas être postérieure à la date d'aujourd'hui.",
  ],
  [
    'REQUEST.LIMIT_EXCEEDED',
    'Vous avez fait trop de demande. Veuillez réessayer plus tard',
  ],
]);
